<template>
<div class="items-might-like">
    <div v-show="loading" style="text-align: center; padding: 25px 0; padding-bottom: 0;">
        <inline-loader></inline-loader>
    </div>
    <v-container grid-list-md fluid>
        <div class="items-might-like__swiper">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="product in products.data" :key="product.id">
                    <div class="product-item">
                        <div class="product-item__content">
                            <div class="product-item__img" @click="redirectToProduct(product.id)">
                                <!-- <img class="img-fluid" :src="product.primary_image" alt=""> -->
                                <v-img :src="product.primary_image" lazy-src="https://digima.sgp1.digitaloceanspaces.com/mybarko/item-placeholder.svg" class="grey darken-4" contain height="150"></v-img>
                                <sale-tag v-if="product.primary_image != ''">
                                    <div class="percent">50%</div>
                                    <div class="off">OFF</div>
                                </sale-tag>
                            </div>
                            <div class="product-item__details">
                                <div class="product-item__details-name substr">{{ product.name }}</div>
                                <div class="product-item__details-price">
                                    <div class="sale">{{ product.price_range }}</div>
                                    <div class="prev-price" v-if="product.price_range == ''">P30</div>
                                </div>
                            </div>
                            <div class="product-item__rating">
                                <heart></heart>
                                <rating-star :rating="product.id"></rating-star>
                            </div>
                            <!-- <v-btn depressed dark small class="text-capitalize" color="#f98436">Buy Now</v-btn> -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- Add Arrows -->
            <!-- <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div> -->
        </div>
    </v-container>
</div>
</template>

<script>
import Swiper from "swiper";
export default {
    data() {
        return {
            products: [],
            loading: false,
        }
    },
    methods: {
        redirectToProduct (id) {
            this.$router.push(
                {
                    path: '/product/'+id,
                }
            )
        },
        getList(){
        this.loading = true
        axios.get(`/api/g/product?page=1&limit=6`)
            .then(response => {
                this.products = response.data.data
                this.products.data.forEach((data,key) => 
                {
                    if (data.galleries.length) 
                    {
                        this.products.data[key].primary_image = data.galleries[0].url_optimized
                    }
                    else
                    {
                        this.products.data[key].primary_image = ""
                    }
                    this.products.data[key].price_range = this.getPriceRange(data.variations)
                })
            })
            .catch(err => {
                this.toaster('something went wrong.', 201);
            })
            .finally(()=> {
                this.loading = false;
                this.loadSwiper()
            });
        },
        loadSwiper(){
            let swiper = new Swiper(".items-might-like__swiper", {
                slidesPerView: 2,
                spaceBetween: 16,
                freeMode: true,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },
                // navigation: {
                //     nextEl: '.swiper-button-next',
                //     prevEl: '.swiper-button-prev',
                // },
            });
        },
        getPriceRange(array)
        {
            if (array.length) 
            {
                var min = array[0].price,
                    max = array[0].price

                var range = null

                array.map((response)=>
                {
                    min = response.price < min ? response.price : min
                    max = response.price > max ? response.price : max
                });

                min = Number.parseFloat(min).toFixed(2)
                max = Number.parseFloat(max).toFixed(2)

                if(min == max)
                {
                    range = "P " + this.numberWithCommas(min);
                }
                else
                {
                    range = "P "+ this.numberWithCommas(min) + " - P "+ this.numberWithCommas(max);
                }
            }
            else
            {
                range = "P " + "0.00"
            }

            return range
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },
    mounted() {

        this.getList()

    }
}
</script>


<style lang="scss">
    .items-might-like__swiper
    {
        position: relative;
    }
</style>
